import React from 'react';
import ProductionNew from './../components/MobileDailyOperation/Productions/ProductionNew';
import CycleTimeNew from './../components/MobileDailyOperation/Productions/CycleTimeNew';
import UtilityNew from './../components/MobileDailyOperation/Productions/UtilityNew';
import PerformanceNew from './../components/MobileDailyOperation/Productions/PerformanceNew';
import IncinerationNew from './../components/MobileDailyOperation/Productions/IncinerationNew';

const Production = ({ selectedDate, setLoading }) => {
  return (
    <div className='flex flex-col change_text'>
      <ProductionNew selectedDate={selectedDate} setLoading={setLoading} />
      <CycleTimeNew selectedDate={selectedDate} setLoading={setLoading} />
      <UtilityNew selectedDate={selectedDate} setLoading={setLoading} />
      <PerformanceNew selectedDate={selectedDate} setLoading={setLoading} />
      <IncinerationNew selectedDate={selectedDate} setLoading={setLoading} />
    </div>
  );
};

export default Production;
